import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cn",
  "use": "icon-cn-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-cn\">\n<g>\n\t<path d=\"M104.5,45.5v21.2h43.3v55.8h-9.1v-6.8h-34.2v38.8h-9.4v-38.8H61.1v7.4h-8.9V66.7h43V45.5H104.5z M95.1,106.9V75.4H61.1\n\t\tv31.6H95.1z M138.7,75.4h-34.2v31.6h34.2V75.4z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol